import { useEffect, useRef, useState } from "react";
import "../assets/css/TestimonialsSection.css";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Restaurant Owner, Delhi",
      feedback:
        "This platform helped my restaurant reach more customers. The delivery and menu management is seamless!",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Mike Chen",
      role: "Grocery Store Owner, Mumbai",
      feedback:
        "I started getting online orders from day one. Super easy to onboard and manage inventory!",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Lisa Rodriguez",
      role: "Franchise Partner, Bangalore",
      feedback:
        "Excellent partner support. The dashboard and delivery system make it really efficient.",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Raj Verma",
      role: "Cloud Kitchen, Pune",
      feedback:
        "A complete platform that helped me scale my kitchen online without hassle.",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Neha Sharma",
      role: "Juice Shop Owner, Jaipur",
      feedback:
        "The delivery integration is super smooth. My daily orders have increased significantly.",
      image:
        "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150&h=150&fit=crop&crop=face",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [cardWidth, setCardWidth] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const transitionDuration = 500;

  // Extend: clone last N at beginning and first N at end
  const extendedTestimonials = [
    ...testimonials.slice(-visibleCount),
    ...testimonials,
    ...testimonials.slice(0, visibleCount),
  ];

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      setVisibleCount(isMobile ? 1 : 3);

      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const gap = isMobile ? 0 : 30;
        const width = isMobile ? containerWidth : 320 + gap;
        setCardWidth(width);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!containerRef.current || cardWidth === 0) return;

    const total = testimonials.length;

    const wrapper = containerRef.current;
    wrapper.style.transition = `transform ${transitionDuration}ms ease-in-out`;
    wrapper.style.transform = `translateX(-${(currentIndex + visibleCount) * cardWidth}px)`;

    // Loop effect
    if (currentIndex === total) {
      const timeout = setTimeout(() => {
        wrapper.style.transition = "none";
        wrapper.style.transform = `translateX(-${visibleCount * cardWidth}px)`;
        setCurrentIndex(0);
      }, transitionDuration);
      return () => clearTimeout(timeout);
    }

    if (currentIndex === -1) {
      const timeout = setTimeout(() => {
        wrapper.style.transition = "none";
        wrapper.style.transform = `translateX(-${(total - 1 + visibleCount) * cardWidth}px)`;
        setCurrentIndex(total - 1);
      }, transitionDuration);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, cardWidth, visibleCount, testimonials.length]);

  return (
    <section className="all-main-section">
      <div className="all-main-section-content-wrapper">
        <h2 className="all-main-title" style={{ textAlign: "center" }}>
          What Our <span> Customers</span> Say
        </h2>

        <div className="testimonials-container" style={{ overflow: "hidden", width: "100%" }}>
          <div className="testimonials-wrapper" ref={containerRef}>
            {extendedTestimonials.map((t, i) => (
              <div
                className="testimonial-card"
                key={i}
                style={{
                  width: visibleCount === 1 ? `${cardWidth}px` : undefined,
                }}
              >
                <img src={t.image} alt={t.name} className="testimonial-image" loading="lazy" />
                <p className="testimonial-feedback">“{t.feedback}”</p>
                <h4 className="testimonial-name">{t.name}</h4>
                <p className="testimonial-role">{t.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
